module.exports = __webpack_public_path__ + "media/svg/linkedin-bbbe0a3e.svg";